import { CognitoUserPool } from "amazon-cognito-identity-js";

// PRODUCTION and STAGING
const poolData = {
  UserPoolId: 'us-east-2_vpCRfIvXD',
  ClientId: '66fovpj4vcp9488lb9o7n3rv58'
};

export default new CognitoUserPool(poolData);
